import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { CHANNEL_PROVIDER_TO_TRANSLATION_KEY } from '../constants';
import { ChannelProviderEnum } from '../types';

export function useChannelProviderOptions(): SelectOptionProps<ChannelProviderEnum>[] {
  const { t } = useTranslation();

  return [
    {
      label: t(CHANNEL_PROVIDER_TO_TRANSLATION_KEY[ChannelProviderEnum.AUDITMEDIA]),
      value: ChannelProviderEnum.AUDITMEDIA,
    },
    {
      label: t(CHANNEL_PROVIDER_TO_TRANSLATION_KEY[ChannelProviderEnum.STACKSCALE]),
      value: ChannelProviderEnum.STACKSCALE,
    },
    {
      label: t(CHANNEL_PROVIDER_TO_TRANSLATION_KEY[ChannelProviderEnum.STREAM]),
      value: ChannelProviderEnum.STREAM,
    },
    {
      label: t(CHANNEL_PROVIDER_TO_TRANSLATION_KEY[ChannelProviderEnum.ACCESO]),
      value: ChannelProviderEnum.ACCESO,
    },
  ];
}
